import flattenIndicatorOutputsForTable from 'utils/flattenIndicatorOutputsForTable';
import mapAddIndicatorResponseToDimensionalRow from 'utils/mapAddIndicatorResponseToDimensionalRow';

import {
  blockHasNonTimeDimensions,
  buildDimItemDataTemplateFromExisting,
  hasDimensionalIndicatorsInTable,
} from './dimensionalIndicatorUtils';

function responseHasDimItemData(raw: Record<string, any>): boolean {
  const dimItemData = raw?.dim_item_data;
  if (!dimItemData) return false;
  if (Array.isArray(dimItemData)) return dimItemData.length > 0;
  if (typeof dimItemData === 'object') return Object.keys(dimItemData).length > 0;
  return false;
}

/**
 * Resolves add_indicator rows for the data table: API dim data, or local template when
 * other indicators already show dimensional breakdown (Opz tableData / indicatorValues pattern).
 */
export default function resolveAddIndicatorForDataTable(
  raw: Record<string, any>,
  indicatorHeaders: { name: string }[],
  existingTableRows: any[],
  plannerBlock?: any,
): any[] {
  let parent = mapAddIndicatorResponseToDimensionalRow(raw, indicatorHeaders);

  const shouldInheritDimStructure =
    !responseHasDimItemData(raw) &&
    blockHasNonTimeDimensions(plannerBlock) &&
    hasDimensionalIndicatorsInTable(existingTableRows);

  if (shouldInheritDimStructure) {
    const template = buildDimItemDataTemplateFromExisting(existingTableRows, indicatorHeaders);
    if (template?.length) {
      parent = { ...parent, dim_item_data: template };
    }
  }

  return flattenIndicatorOutputsForTable(parent);
}
